(() => {
  if (window.sfLineupInitialized || !window.EmblaCarousel || !window.sfSlider) return;
  window.sfLineupInitialized = true;
  const init = root => {
    if (root.sfSlider) return;
    const viewport = root.querySelector('[data-lineup-viewport]');
    const container = root.querySelector('.sf-home-lineup__grid');
    const slides = [...root.querySelectorAll('[data-home-product-card]')];
    if (!viewport || !slides.length) return;
    root.dataset.lineupReady = 'true';
    // Align actual text rows rather than reserving large fixed empty spaces.
    const alignCopy = () => {
      for (const selector of ['.sf-product-card__copy > .sf-eyebrow', '.sf-product-card__copy h3', '.sf-product-card__copy > p:not(.sf-eyebrow)']) {
        const nodes = slides.map(slide => slide.querySelector(selector)).filter(Boolean);
        nodes.forEach(node => node.style.minHeight = '');
        if (slides[0].offsetWidth < viewport.clientWidth - 4) {
          const height = Math.max(...nodes.map(node => node.offsetHeight));
          nodes.forEach(node => node.style.minHeight = `${height}px`);
        }
      }
    };
    alignCopy();
    const carousel = window.EmblaCarousel(viewport, {
      container, slides, align: 'start', loop: false, slidesToScroll: 'auto', containScroll: 'trimSnaps', inViewThreshold: .5,
      duration: matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 25,
    });
    window.sfSlider(root, carousel, { viewport, slides, label: 'Product page', onResize: alignCopy });
  };
  const initAll = (scope = document) => scope.querySelectorAll('[data-product-lineup]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-product-lineup]').forEach(root => { root.sfSlider?.destroy(); delete root.dataset.lineupReady; }));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-home-product-card]'), root = slide?.closest('[data-product-lineup]');
    root?.sfSlider?.selectSlide([...root.querySelectorAll('[data-home-product-card]')].indexOf(slide));
  });
  document.addEventListener('shopify:block:deselect', event => event.target.closest('[data-product-lineup]')?.sfSlider?.deselect());
})();
